import { render, staticRenderFns } from "./generalMaster.vue?vue&type=template&id=b5df2ed6&scoped=true"
import script from "./generalMaster.vue?vue&type=script&lang=js"
export * from "./generalMaster.vue?vue&type=script&lang=js"
import style0 from "./generalMaster.vue?vue&type=style&index=0&id=b5df2ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5df2ed6",
  null
  
)

export default component.exports